// API returns money/decimal as strings to preserve precision.
// For display, format with 2 dp; keep as strings on the way back to the server.

export function formatMoney(value, currency = "GBP") {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return String(value);
  const symbol = currency === "EUR" ? "€" : currency === "USD" ? "$" : "£";
  return `${symbol}${num.toFixed(2)}`;
}

export function formatPct(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(num)) return String(value);
  return `${num.toFixed(2)}%`;
}

export function toDecimalString(input) {
  if (input === null || input === undefined || input === "") return "";
  return String(input);
}
